import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/account.css";
import "../../assets/css/user_profile.css";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const MyProfile = () => {
	const [disabled, setDisabled] = useState(true);

	useEffect(() => {}, []);
	function handleGameClick() {
		setDisabled(!disabled);
	}
	const stopSubmit = (event) => {
		event.preventDefault();
	};
	return (
		<>
			<AuthHeader />
			{/* My Profile starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* Account starts here */}
							<div className="account-form-wrapper">
								<div className="account-heading-wrapper">
									<h3>Account</h3>
								</div>
								<form action="" onSubmit={stopSubmit}>
									<div className="form-group row">
										<div className="col-lg-5">
											<label htmlFor="">First Name</label>
											<input
												type="text"
												defaultValue="John"
												className="form-control"
												disabled={disabled}
											/>
										</div>
										<div className="col-lg-5">
											<label htmlFor="">last Name</label>
											<input
												type="text"
												defaultValue="Doe "
												className="form-control"
												disabled={disabled}
											/>
										</div>
									</div>
									<div className="form-group row">
										<div className="col-lg-5">
											<label htmlFor="">Phone Number</label>
											<input
												type="text"
												defaultValue="+123 - 456 - 789"
												className="form-control"
												disabled={disabled}
											/>
										</div>
										<div className="col-lg-5">
											<label htmlFor="">Email</label>
											<input
												type="text"
												defaultValue="Johndoe@apricoat.com "
												className="form-control"
												disabled={disabled}
											/>
										</div>
									</div>
									<div className="form-group">
										<button
											className="btn"
											type="submit"
											onClick={handleGameClick}
										>
											{disabled ? "Edit Profile" : "Save Changes"}
										</button>
									</div>
								</form>
							</div>
							{/* Account ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My Profile starts here */}
			<Footer />
		</>
	);
};

export default MyProfile;
